import { render, staticRenderFns } from "./yxmarketing_edit.vue?vue&type=template&id=51f81797&scoped=true&"
import script from "./yxmarketing_edit.vue?vue&type=script&lang=js&"
export * from "./yxmarketing_edit.vue?vue&type=script&lang=js&"
import style0 from "./yxmarketing_edit.vue?vue&type=style&index=0&id=51f81797&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f81797",
  null
  
)

export default component.exports